module.exports = __webpack_public_path__ + "img/loginBg.f3d92c3d.png";